import React, { useState } from "react";
import "./SliderButton.css";

const SliderButton = ({
  leftLabel,
  rightLabel,
  onToggle,
  showHoverEffect = false,
  leftHoverText = "",
  rightHoverText = "",
}) => {
  const [selected, setSelected] = useState(leftLabel);
  const [hoverText, setHoverText] = useState("");

  const handleToggle = () => {
    const newSelection = selected === leftLabel ? rightLabel : leftLabel;
    setSelected(newSelection);
    onToggle(newSelection);
  };

  const handleMouseEnter = (label) => {
    if (showHoverEffect) {
      setHoverText(label === leftLabel ? leftHoverText : rightHoverText);
    }
  };

  const handleMouseLeave = () => {
    setHoverText("");
  };

  return (
    <div
      className="slider-container-comp"
      onClick={handleToggle}
      onMouseLeave={handleMouseLeave}
    >
      <span
        className="slider-label-left-comp"
        onMouseEnter={() => handleMouseEnter(leftLabel)}
      >
        {leftLabel}
      </span>
      <div
        className={`slider-button-comp ${
          selected === leftLabel ? "left-comp" : "right-comp"
        }`}
      ></div>
      <span
        className="slider-label-right-comp"
        onMouseEnter={() => handleMouseEnter(rightLabel)}
      >
        {rightLabel}
      </span>
      {showHoverEffect && hoverText && (
        <div className="hover-info-box-comp">{hoverText}</div>
      )}
    </div>
  );
};

export default SliderButton;
